
//Import React Hooks
import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom' //useParams to get the id transmitted in the url

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :
import Background from '../../components/background/Background.jsx'
import ProgressBar from '../../components/progressbar/ProgressBar.jsx'
import BottomNav from '../../components/bottomnav/BottomNav.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getSelectedCreneaux, getFormules, getEleves, getFormulesEleves, getResa } from "../../store/selectors.js";
import { resaSlice } from "../../store/resaSlice.js";
import { elevesSlice } from "../../store/elevesSlice.js";
import { clientSlice } from "../../store/clientSlice.js";
import { commentaireSlice } from "../../store/commentaireSlice.js";
import { formulesElevesSlice } from "../../store/formulesElevesSlice.js";
import { selectedCreneauxSlice } from "../../store/selectedCreneauxSlice.js";

// API fetch
import axios from "axios";
import { baseURL, appURL } from '../../config/api-config.js';

//Utils 
import { creneauxSorter2 } from '../../utils/creneaux_sorter.js';
import convertHoraire from '../../utils/convert_horaire.js';
import elevesSorter from '../../utils/eleves_sorter.js';
import getTotalResa from '../../utils/total_resa.js';
//Utils 
import setNumResa from '../../utils/set_num_resa.js';

//config
import { listFidelite, listNiveau } from "../../config/niveau-fidelite-config.js";



//MUI :
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import { TryOutlined } from '@mui/icons-material';

function ResaSuccess() { // full page as component imported in router

    const navigate = useNavigate();
    const dispatch = useDispatch();
    let thisResa = useSelector(getResa);
    //console.log(thisResa);
    //let formulesList = useSelector(getFormules);
    //let formulesList = [];
    //let resaInfos = {};
    let [formulesList, setFormuleList] = useState([]);
    let [resaInfos, setResaInfos] = useState({});
    let [htmlMail, setHtmlMail] = useState("");
    let [htmlMailYann, setHtmlMailYann] = useState("");
    let [clientMail, setClientMail] = useState();
    let [clientName, setClientName] = useState();
    let [resaNum, setResaNum] = useState();
    let [sent, setSent] = useState(false);
    let [sentYann, setSentYann] = useState(false);
    let [fail, setFail] = useState(false);



    //// --
    useEffect(() => {
        console.log(resaInfos);
        if (Object.keys(resaInfos).length > 0 && formulesList.length > 0) {
            setHtmlMail(prepaMail(resaInfos, formulesList, thisResa).client);
            setHtmlMailYann(prepaMail(resaInfos, formulesList, thisResa).yann);
            setClientMail(prepaMail(resaInfos, formulesList, thisResa).dest);
            setResaNum(prepaMail(resaInfos, formulesList, thisResa).ref);
            setClientName(prepaMail(resaInfos, formulesList, thisResa).name);
        }
    }, [resaInfos, formulesList])
    //// -- 

    //// --
    useEffect(() => {
        console.log(htmlMail);

        // console.log(htmlMail);
        if (htmlMail === "" || sent === true) { return; }//// block useEffect at every render
        //console.log(resaInfos);

        let body = {
            //to: "manuel.vivion@gmail.com", //// -- resaInfos.client.email
            to: clientMail, //// -- resaInfos.client.email
            subject: "Nous avons bien reçu votre demande de réservation " + resaNum,
            html: htmlMail
        };

        setSent(true);

        axios.post(`${baseURL}/mailing/mail-confirm`, body)
            .then((response) => {
                if (response.status === 201) { //isnertion OK
                    setFail(false); //to not trigger alert message
                    //console.log(response.data)

                }
                else { //mail problème
                    setFail(true); //to trigger alert message
                    return response.status
                }
            })
            .catch(error => {
                setFail(true); //to trigger alert message
                return error
            })

    }, [htmlMail])
    //// -- 

    //// --
    useEffect(() => {
        console.log(htmlMailYann);

        if (htmlMailYann === "" || sentYann === true) { return; }//// block useEffect at every render

        let body = {
            //to: "manuel.vivion@gmail.com", //// -- wallyglisse@gmail.com
            to: "wallyglisse@gmail.com",
            subject: `(${clientName} : 1 ) - Demande de réservation reçue - ${resaNum}`,
            html: htmlMailYann,
            client: clientName
        };

        setSentYann(true);

        axios.post(`${baseURL}/mailing/mail-reception-demande`, body)
            .then((response) => {
                if (response.status === 201) { //isnertion OK
                    setFail(false); //to not trigger alert message
                    //console.log(response.data)

                }
                else { //mail problème
                    setFail(true); //to trigger alert message
                    return response.status
                }

            })
            .catch(error => {
                setFail(true); //to trigger alert message
                return error
            })

    }, [htmlMailYann])
    //// -- 


    // load formules from DB
    async function initResa() { //we add this inner function to manage asynchrone
        //resaInfos = await fetchResa();
        setResaInfos(await fetchResa());
        //formulesList = await fetchFormules();
        setFormuleList(await fetchFormules());
        /* setHtmlMail(prepaMail(resaInfos, formulesList, thisResa).client);
        setHtmlMailYann(prepaMail(resaInfos, formulesList, thisResa).yann);
        setClientMail(prepaMail(resaInfos, formulesList, thisResa).dest);
        setResaNum(prepaMail(resaInfos, formulesList, thisResa).ref);
        setClientName(prepaMail(resaInfos, formulesList, thisResa).name); */
        resetRedux();
    } //end of async function

    if (Object.keys(resaInfos).length === 0 && formulesList.length === 0) {
        initResa(); //call the inner asnchrone function
    }




    async function fetchResa() { // get list of formules from DB

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/resa/${thisResa.id_resa}`,
            });
            //console.log(response.data);
            const resa = response.data;
            return resa;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    async function fetchFormules() { // get list of formules from DB

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/formule`,
            });
            //console.log(response.data);
            const formules = response.data;
            return formules;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    function resetRedux() {
        dispatch(elevesSlice.actions.initEleves([]));
        dispatch(formulesElevesSlice.actions.resetFormulesEleves());
        dispatch(commentaireSlice.actions.setCommentaire(""));
        dispatch(clientSlice.actions.setClient({}));
        //dispatch(resaSlice.actions.setResa({}));
        dispatch(selectedCreneauxSlice.actions.initCreneaux([]));
    }


    return (
        <div className="bg-relative">
            <Background ind={1} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner />
                    <div className="resa-success">

                        <div className="resa-success-top">
                            <h3>Votre demande de réservation a bien été enregistrée.</h3>
                        </div>
                        <div className="resa-success-middle">
                            <p><CheckIcon />{`L'équipe de Wally Glisse va très bientôt recevoir votre demande (num. ${thisResa.numResa}).`}</p>
                            <p><CheckIcon />{`En fonction des plannings, des horaires de marées et de la météo, Nous pourrons valider votre demande directement ou non.\n Si la validation de notre part n'est pas directe, aucun soucis, nous vous envoyons dans la foulée une nouvelle proposition de sessions.\n`}

                                <CheckIcon />{`Surveillez vos emails, vous serez informés très bientôt (Pensez à vérifier dans vos spams au cas où...).`}
                            </p>
                        </div>
                        <div className="resa-success-bottom">
                            <p>En attendant, vous pouvez fermer cet onglet ou faire un autre demande de réservation si vous le souhaitez.</p>

                            <Button
                                className="bottom-nav-retry"
                                disabled={htmlMail === ""}
                                onClick={_ => navigate("../")}
                                variant="contained">
                                Refaire une réservation
                            </Button>
                        </div>

                    </div>
                </div>
            </main>
        </div>
    );
}

export default ResaSuccess;


function prepaMail(allResaInfos, formulesList, thisResa) {

    let allEleves = [];
    let allCreneaux = [];

    console.log(allResaInfos);
    console.log(thisResa);

    allResaInfos.CreneauEleves.map((creneauEleve) => { // for every line in CreneauEleve Table...

        //// -- We want a list of eleves

        // if eleve not in the list already...
        if (allEleves.filter((eleve) => eleve.id === creneauEleve.Eleve.id_eleve).length === 0) {
            allEleves.push({  //... we add this eleve to the list, with his infos reformated for global state "Eleves" 
                id: creneauEleve.Eleve.id_eleve,
                prenom: creneauEleve.Eleve.prenom,
                age: creneauEleve.Eleve.age,
                niveau: listNiveau.find((niveau) => niveau.id === creneauEleve.Eleve.niveau_id).intitule,
                fidelite: listFidelite.find((fid) => fid.id === creneauEleve.Eleve.fidelite_id).intitule,
                checked: true
            });
            allEleves.sort((e1, e2) => e1.id > e2.id ? 1 : -1); // We sort the list of eleves, as they "arrive" in disorder
        }

        allCreneaux.push({
            eleve_id: creneauEleve.Eleve.id_eleve,
            date: creneauEleve.Creneau.date,
            horaire: creneauEleve.Creneau.horaire,
        });

    });// end of map

    function getFormulesInfos(eleve) {
        let nbcours = allCreneaux.filter((creneau) => creneau.eleve_id === eleve.id).length;
        let currentFormule = formulesList.find((f) => f.nb_cours === nbcours);
        //console.log(nbcours, formulesList);
        return currentFormule.nom_formule + ", " + currentFormule.tarif + ",00€"
    }

    function formatCreneauInfos(creneau) {
        let infos = "le " + dayjs(creneau.date).format("DD/MM");
        infos += " à " + convertHoraire(creneau.horaire, "horaire");
        return infos;
    }



    let htmlBody = `<html lang='fr'>
    <head>
        <meta charset='UTF-8'>
        <style>
        body {
            background-color: white;
            font-family: Arial, Helvetica, sans-serif;
            text-align: justify;
            margin: 0;
        }

        p {
            font-size: 14px;
        }

        section {
            background-color: #eee;
            width: 90%;
            margin: 16px auto;
            padding: 16px;
            border-bottom: 1px solid #E91E63;
        }

        h3 {
            text-align: center;
            text-decoration: underline;
        }

        .intro h3 {
            text-decoration: none;
        }

        .commentaire p {
            margin: 6px;
        }

        .commentaire .p2 {
            font-weight: bold;
        }

        .coordonnees .client,
        .coordonnees .wally {
            width: 70%;
            margin: auto;
            background-color: #dedede;
            padding: 8px;
        }

        .coordonnees p {
            margin: 8px;
        }

        .coordonnees .p1 {
            font-size: 16px;
            font-weight: bold;
        }


        .formules .bloc-eleve {
            background-color: white;
            padding: 4px 16px;
            border-radius: 5px;
            margin: 8px;
            min-width: 400px;
        }

        .formules .p1 {
            text-decoration: underline;
            font-size: 16px;
            font-weight: bold;
        }

        .formules .p2 {
            margin-bottom: 16px;
            font-weight: bold;
            color: #555;
        }

        .formules .session {
            margin: 8px;
        }


        .bouton-match,
        .bouton-modif {
            display: block;
            padding: 16px 32px;
            background-color: #E91E63;
            border-radius: 5px;
            margin: 4px 8px;
            color: white;
            cursor: pointer;
            font-size: large;
            width: 280px;
            margin: auto;
            margin-bottom: 16px;
            text-align: center;
        }

        a:link,
        a:visited,
        a:active,
        a:hover {
            text-decoration: none;
        }

        .bouton-modif {
            background-color: #34B0EE;
        }
    </style>
    
    </head>
    `;

    //// ---- Init Yann ----------------------

    let htmlBodyYann = htmlBody;

    //// ---- Client ----------------------

    htmlBody += `<body><section class="intro"><h3>Bonjour ${allResaInfos.Client.prenom},</h3><p class="intro p1">Merci de nous avoir envoyé votre demande de réservation. Nous l'avons bien reçu et nous allons la traiter rapidement...</p><p class="intro p2">Surveillez vos mails, vous allez recevoir bientôt, soit une confirmation de notre part, soit une proposition avec de nouveaux horaires de sessions en fonction de nos disponibilité, des horaires de marées...</p><p>Votre numéro de réservation : ${thisResa.numResa}</p></section><section class="formules"><h3>Rappel de vos formules : </h3><div class="formules container">`;
    //// ---- Yann ----------------------

    htmlBodyYann += `<body>

        <section class="intro">
            <h3>Bonjour Yann,</h3>
            <p class="intro p1">Tu as reçu une demande de réservation de la part de ${allResaInfos.Client.prenom} ${allResaInfos.Client.nom}</p>
            <p class="intro p2">Date de la demande de réservation : ${dayjs(allResaInfos.created).format("DD/MM/YYYY HH:mm")} </p>
            <p>Son numéro de réservation : ${thisResa.numResa}</p>
        </section>
    
        <section class="formules">
            <h3>Voici la liste des formules demandées : </h3>
            <div class="formules container">`;

    //// ---- Client + Yann ----------------------

    console.log(allEleves);


    allEleves.map((eleve) => {

        htmlBody += `<div class="formules bloc-eleve"><p class="formules p1">Elève : ${eleve.prenom}, age : ${eleve.age} / ${eleve.niveau} / ${eleve.fidelite}</p><p class="formules p2">Formule : ${getFormulesInfos(eleve)}</p>`;


        htmlBodyYann += ` <div class="formules bloc-eleve">
          <p class="formules p1">Elève : ${eleve.prenom}, age : ${eleve.age} / ${eleve.niveau} / ${eleve.fidelite}</p>
          <p class="formules p2">Formule : ${getFormulesInfos(eleve)}</p>`;


        allCreneaux.toSorted((c1, c2) => creneauxSorter2(c1, c2)).filter((creneau) => creneau.eleve_id === eleve.id).map((creneau, index) => {
            htmlBody += `<p class="formules session">Session ${index + 1} : ${formatCreneauInfos(creneau)}</p>`;
            htmlBodyYann += `<p class="formules session">Session ${index + 1} : ${formatCreneauInfos(creneau)}</p>`;
        })


        htmlBody += `</div>`;
        htmlBodyYann += `</div>`;
    })

    //// ---- Client ----------------------

    htmlBody += `</div><div><h3>Montant total de votre panier : ${allResaInfos.total},00€</h3></div></section>`

    if (allResaInfos.ResaCommentaires.length > 0) {
        htmlBody += `<section class="commentaire"><p>Vous avez rédigé un commentaire :</p><p class="commentaire p2">${allResaInfos.ResaCommentaires.length > 0 ? allResaInfos.ResaCommentaires[0].commentaire : " "}</p></section>`;
    }

    //// ---- Yann ----------------------

    htmlBodyYann += `
    </div>

        <div>
            <h3>Montant total du panier : ${allResaInfos.total},00€</h3>
        </div>

    </section>
    <section class="boutons-liens">
        <a href="${appURL + "/matchresa/" + allResaInfos.id_resa + "/" + allResaInfos.Client.id_client}" target="_blank">
            <p class="bouton-match">Matcher direct</p>
        </a>
        <a href="${appURL + "/editresa/" + allResaInfos.id_resa + "/" + allResaInfos.Client.id_client}" target="_blank">
            <p class="bouton-modif">Modifier la réservation</p>
        </a>
    </section>
    `

    if (allResaInfos.ResaCommentaires.length > 0) {
        htmlBodyYann += `<section class="commentaire">
        <p>Le client a rédigé un commentaire :</p>
        <p class="commentaire p2">${allResaInfos.ResaCommentaires.length > 0 ? allResaInfos.ResaCommentaires[0].commentaire : ""}</p>
        </section>`;
    }

    //// ---- client ----------------------

    htmlBody += `<section class="coordonnees"><h3>Vos coordonnées : </h3><div class="coordonnees client"><p class="coordonnees p1">${allResaInfos.Client.prenom + " " + allResaInfos.Client.nom}</p><p>email : ${allResaInfos.Client.email}</p><p>tel : ${allResaInfos.Client.tel}</p><p>tel 2 : ${allResaInfos.Client.tel2}</p><p>adresse vacances : ${allResaInfos.Client.adresse_vacances}</p></div><h3>Nos coordonnées : </h3><div class="coordonnees wally"><p class="coordonnees p1">Wally Glisse</p><p>wallyglisse@gmail.com</p><p>tel : +33 (0)6 19 07 05 53</p></div></section></body></html>`;

    //// ---- Yann ----------------------

    htmlBodyYann += `
    <section class="coordonnees">
    <h3>Coordonnées du client: </h3>
    <div class="coordonnees client">
        <p class="coordonnees p1">${allResaInfos.Client.prenom + " " + allResaInfos.Client.nom}</p>
        <p>email : ${allResaInfos.Client.email}</p>
        <p>tel : ${allResaInfos.Client.tel}</p>
        <p>tel 2 : ${allResaInfos.Client.tel2}</p>
        <p>adresse vacances : ${allResaInfos.Client.adresse_vacances}</p>
    </div>

</section>
</body>

</html>`;


    return ({ client: htmlBody, yann: htmlBodyYann, dest: allResaInfos.Client.email, ref: thisResa.numResa, name: allResaInfos.Client.nom });
}